import axios from '../globalAxios';
import { appConfig } from '../../config';

const baseUrl = appConfig.api.baseUrl;

export default class WishlistApi {
    static getAllLists = () => axios.post(baseUrl + 'Wishlist/GetAllLists');

    static getWishListItems = (listname: string) =>
        axios.post(baseUrl + 'Wishlist/GetWishListItems', null, { params: { listname } });

    static getWishListSummary = (listname: string) =>
        axios.post(baseUrl + 'Wishlist/GetWishListSummary', null, { params: { listname } });

    /** WishListProductDto[] — product (LookupMaster shape). Order types: GetAllItemOrderTypes on overlay open. */
    static getWishList = (params: { listname?: string; wishListDefId?: number }) =>
        axios.post(baseUrl + 'Wishlist/GetWishList', null, { params });

    static addItemToWishList = (
        listname: string,
        masterid: string,
        colorcode: string,
        additional: string = ''
    ) =>
        axios.post(baseUrl + 'Wishlist/AddItemToWishList', null, {
            params: { listname, masterid, colorcode, additional },
        });

    /** Backend parameter is misspelled `colorocde` — must match API binding */
    static deleteItemFromWishList = (listname: string, masterid: string, colorocde: string) =>
        axios.post(baseUrl + 'Wishlist/DeleteItemFromWishList', null, {
            params: { listname, masterid, colorocde },
        });

    /** Phase 2: wire `clearWishlist` thunk to this when `Wishlist/ClearWishList` is deployed. */
    static clearWishList = (listname: string) =>
        axios.post(baseUrl + 'Wishlist/ClearWishList', null, { params: { listname } });
}
